import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { colors } from '../../../../../../../../styles/theme';

export const IconStyled = styled(FontAwesomeIcon)`
  color: ${colors.color1};
`;
